export class Document {
    constructor(public data: {
        Id?: Number,
        Caption?: String,
        Filename?: String
    }) { }
}